import { apiFetch } from "./api-client";

export type OfficeUserRole = "Admin" | "Dispatcher" | "Technician";

export type OfficeUser = {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  isOwner: number;
  active: boolean;
  role: string;
  isTechnician: boolean;
  dispatchable: boolean;
  technicianActive: boolean;
};

type ApiPayload<T> = {
  data?: T;
  error?: { message?: string };
};

async function responseData<T>(
  response: Response,
  fallbackMessage: string,
): Promise<T> {
  const payload = (await response.json()) as ApiPayload<T>;
  if (!response.ok || !payload.data) {
    throw new Error(payload.error?.message || fallbackMessage);
  }
  return payload.data;
}

export async function inviteOfficeUser(input: {
  name: string;
  email: string;
  role: OfficeUserRole;
}) {
  const response = await apiFetch("/api/v1/workspace/users", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
  return responseData<{ item: OfficeUser }>(
    response,
    "Unable to invite team member",
  );
}

export async function updateOfficeUserActive(userId: string, active: boolean) {
  const response = await apiFetch(
    `/api/v1/workspace/users/${encodeURIComponent(userId)}`,
    {
      method: "PATCH",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ active }),
    },
  );
  return responseData<{ item: Pick<OfficeUser, "id" | "active"> }>(
    response,
    "Unable to update team member",
  );
}
